import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, moreTo, moreLabel }: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-block text-xs font-bold tracking-[0.25em] text-accent-600 font-label mb-2">
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {desc && <p className="mt-2 text-sm text-foreground-500 max-w-2xl">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap shrink-0"
        >
          {moreLabel || '查看更多'}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}